module.exports = __webpack_public_path__ + "static/media/snow_med.c1c8e94a.svg";